export const blogPosts = [
  {
    id: 1,
    title: {
      es: 'Energías Florecientes – Armonía con Flores y Cristales de Cuarzo',
      en: 'Flourishing Energies – Harmony with Flowers and Quartz Crystals'
    },
    image: 'https://dgexpressec.com/images/kosmoflowers/idea.png',
    summary: {
      es: 'Descubre cómo las flores y los cristales pueden transformar la energía de tu espacio.',
      en: 'Discover how flowers and crystals can transform your space\'s energy.'
    },
    content: {
      es: `
      En el ajetreo diario, todos necesitamos un rincón donde la energía fluya en equilibrio. ¿Qué mejor manera de crear ese espacio que con la magia de las flores y los cristales de cuarzo? Este es el enfoque detrás de nuestros arreglos florales energéticos: piezas que no solo decoran, sino que transforman.

      La Magia de las Flores y los Cristales
      Cada flor tiene una vibración especial. Por ejemplo:

      • Rosas: Simbolizan amor y armonía.
      • Girasoles: Llenan de vitalidad y positivismo.
      • Lirios: Favorecen la paz y la serenidad.

      Cuando combinamos estas flores con cristales como el cuarzo rosa (amor incondicional), amatista (tranquilidad) y cuarzo transparente (energía pura), creamos un impacto poderoso en el ambiente.

      Beneficios Energéticos
      • Equilibrio emocional: Las flores y los cristales trabajan juntos para promover calma y estabilidad.
      • Energía renovada: Mejoran la atmósfera, llenando los espacios de luz y optimismo.
      • Belleza con propósito: Cada arreglo es una obra de arte que eleva tu estado de ánimo.

      Crea tu Espacio Energético
      Nuestros arreglos están diseñados para cualquier ocasión: desde un regalo lleno de intenciones positivas hasta decoraciones personales para revitalizar tu hogar o lugar de trabajo. ¡Elige el tuyo y deja que las buenas energías fluyan!
      `,
      en: `
      In the daily hustle and bustle, we all need a corner where energy flows in balance. What better way to create that space than with the magic of flowers and quartz crystals? This is the approach behind our energetic floral arrangements: pieces that not only decorate but transform.

      The Magic of Flowers and Crystals
      Each flower has a special vibration. For example:

      • Roses: Symbolize love and harmony.
      • Sunflowers: Fill with vitality and positivity.
      • Lilies: Promote peace and serenity.

      When we combine these flowers with crystals like rose quartz (unconditional love), amethyst (tranquility), and clear quartz (pure energy), we create a powerful impact in the environment.

      Energetic Benefits
      • Emotional balance: Flowers and crystals work together to promote calm and stability.
      • Renewed energy: They improve the atmosphere, filling spaces with light and optimism.
      • Beauty with purpose: Each arrangement is a work of art that elevates your mood.

      Create Your Energetic Space
      Our arrangements are designed for any occasion: from a gift full of positive intentions to personal decorations to revitalize your home or workplace. Choose yours and let the good energies flow!
      `
    },
    date: '2024-12-08',
    author: 'Kosmo Flowers',
    tags: {
      es: ['flores', 'cristales', 'energía', 'armonía', 'bienestar'],
      en: ['flowers', 'crystals', 'energy', 'harmony', 'wellness']
    },
    relatedProducts: ['harmony-bloom', 'healing-light', 'sacred-shield']
  }
];
